import { wei } from '@kwenta/wei';
export const sqrtToPrice = (sqrtPrice, decimals0, decimals1, token0IsInput = true) => {
    const numerator = sqrtPrice ** 2n;
    const denominator = 2n ** 192n;
    let ratio = wei(numerator).div(denominator).toBigInt();
    const shiftDecimals = BigInt(10 ** (decimals0 - decimals1));
    ratio = ratio * shiftDecimals;
    return token0IsInput ? ratio : wei(1).div(ratio).toBigInt();
};
